import { storeToRefs } from 'pinia';
import useTransactionsStore from '@/store/modules/transactions';
import SideMenu from '@/components/SideMenu.vue';
import { useGeneralStore } from '@/store/modules/general';
import { setNewEncryptionToken } from '@/utils/csrf';
import { onMounted } from 'vue';
import Toast from './components/general/Toast.vue';
async function setToken() {
    await setNewEncryptionToken();
    setInterval(async () => {
        await setNewEncryptionToken();
    }, 3600000);
}
export default {
    name: 'App',
    components: {
        SideMenu,
        Toast,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const generalStore = useGeneralStore();
        const { showSideMenu } = storeToRefs(transactionsStore);
        const { toastMessage, showingToast } = storeToRefs(generalStore);
        const closeSideMenu = (evt) => {
            evt.stopImmediatePropagation();
            if (showSideMenu.value) {
                showSideMenu.value = false;
            }
        };
        const onKeyUp = () => {
            console.log('');
        };
        onMounted(async () => {
            document.title = 'Yellow Card Widget';
            await setNewEncryptionToken();
            /*
             * We use the current hour to generate the CSRF token
             * This ensures it auto refreshes at the top if every hour
             */
            const curHour = new Date().getHours();
            const nextHour = new Date();
            nextHour.setHours(curHour + 1);
            nextHour.setMinutes(0);
            nextHour.setSeconds(0);
            const msToNextHour = nextHour.getTime() - new Date().getTime();
            setTimeout(async () => {
                await setToken();
            }, msToNextHour);
        });
        return {
            showSideMenu,
            toastMessage,
            showingToast,
            closeSideMenu,
            onKeyUp,
        };
    },
};
